export default "__VITE_ASSET__BANtYmEE__"